// Einstieg der People-App (/). Besitzer: ui-basis.
import { startPlatform } from '@web/app/bootstrap';
import { galerieRoute } from '@web/galerie/route';
import { PeopleShell } from './Shell';

void startPlatform({ platform: 'people', Shell: PeopleShell, builtinPublicRoutes: [galerieRoute] });
